import { FetchError } from "./client/client"

export const isFetchError = (error: any): error is FetchError => {
  return error instanceof FetchError
}
